import { render, staticRenderFns } from "./Section3.vue?vue&type=template&id=b29d6f18"
import script from "./Section3.vue?vue&type=script&lang=js"
export * from "./Section3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports